module.exports = __webpack_public_path__ + "dstore.6pfgV5iU.png";